export var COOKIE_PREFERENCES_COOKIE = 'OptanonConsent';
export var ANALYTICAL_EXPERIENCE_COOKIES_GROUP = 'C0007';
export var FUNCTIONAL_COOKIES_GROUP = 'C0003';
export var PERFORMANCE_COOKIES_GROUP = 'C0002';
export var TARGETING_ADVERTISING_COOKIES_GROUP = 'C0004';
export var TECHNICAL_COOKIES_GROUP = 'T0001';
export var CONSENT_TRUE_FLAG = '1';
export var DATA_DOMAIN_SCRIPT = '52a28b58-7a56-4776-a0ae-7a3cda34da20';
export var DATA_DOMAIN_SCRIPT_TESTING = "".concat(DATA_DOMAIN_SCRIPT, "-test");
export var COOKIE_MODAL_SCRIPT_PRELOAD_URL = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
export var COOKIE_MODAL_SCRIPT_PRECONNECT_HREF = 'https://cdn-ukwest.onetrust.com';